// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Mo-z","imageAndVideoCount":"No-z","imageAndVideoContainer":"Oo-z","viewAllReviews":"Po-z"};